function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForHumansNavajoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1792.7mm",
    height: "183.83mm",
    viewBox: "0 0 1792.7 183.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-87.829 111.52)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 75.151039,
    y: 68.868851,
    style: {
      fill: "none",
      fontFamily: "'Bodoni 72 Oldstyle'",
      fontSize: "282.22px",
      paintOrder: "markers fill stroke",
      strokeWidth: 25,
      stroke: "#ffe0ad"
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 75.151039,
    y: 68.868851,
    style: {
      fill: "#ffe0ad",
      fontFamily: "Courier",
      fontSize: "282.22px",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      strokeWidth: 25,
      stroke: "none"
    }
  }, "For humans."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForHumansNavajoWhite);
export default __webpack_public_path__ + "static/media/for_humans_navajo_white.5a74d7c88e1e28963a2dee8bc780932d.svg";
export { ForwardRef as ReactComponent };